import { Action, createReducer, on } from '@ngrx/store';
import { IThirdPartyReportState } from './third-party-report';
import { ResponseReteterzaReport } from '../../interfaces/response-reteterza-report';
import { RESET_RETE_TERZA_STORE, RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER_SUCCESS, RETRIEVE_DETTAGLIO_PUNTO_POSTE_SUCCESS, RETRIEVE_REPORT_PUNTO_POSTE_LOCKER_SUCCESS, RETRIEVE_RETETERZA_REPORT_SUCCESS, RETRIEVE_RETILOCKER_REPORT_SUCCESS } from './third-party-report.actions';
import { IResponsePuntoPosteDetail } from '../../interfaces/retrive-dettaglio-punto-poste';
import { ResponseRetiLockerReport } from '../../interfaces/response-reti-locker-report';
import { IResponseReportPuntoPosteLocker } from '../../interfaces/response-report-punto-poste-locker';
import { IResponsePuntoPosteLockerDetail } from '../../interfaces/retrieve-punto-poste-locker-detail';

/* INITIAL STATE */
const initialState: IThirdPartyReportState = {
  reteterzaReport: null,
  selectResponseReteterzaReport: null,
  retiLockerReport: null,
  dettaglioPuntoPoste: null,
  reponsePuntoPosteLocker: null,
  dettaglioPuntoPosteLocker: null,
};

const handleSaveReteterzaReport = (
  state: IThirdPartyReportState,
  { reteterzaReport }: { reteterzaReport: ResponseReteterzaReport | null}
): IThirdPartyReportState => {
  return {
    ...state,
    reteterzaReport: reteterzaReport?.retiTerze||null,
    selectResponseReteterzaReport: reteterzaReport,
  };
};

const handleSaveRetiLockerReport = (
  state: IThirdPartyReportState,
  { retiLockerReport }: { retiLockerReport: ResponseRetiLockerReport }
): IThirdPartyReportState => {
  return {
    ...state,
    retiLockerReport: retiLockerReport.retiLocker,
  };
};

//TODO: Fix type handleRetrievePuntoPosteLocker
const handleRetrievePuntoPosteLocker = (
  state: IThirdPartyReportState,
  { reponsePuntoPosteLocker }: { reponsePuntoPosteLocker: IResponseReportPuntoPosteLocker }
): IThirdPartyReportState => {
  return {
    ...state,
    reponsePuntoPosteLocker,
  };
};

const handleSaveDettaglioPuntoPoste = (
  state: IThirdPartyReportState,
  { dettaglioPuntoPoste }: { dettaglioPuntoPoste: IResponsePuntoPosteDetail | null }
): IThirdPartyReportState => {
  return {
    ...state,
    dettaglioPuntoPoste,
  };
};

const handleDettaglioPuntoPosteLocker = (
  state: IThirdPartyReportState,
  { dettaglioPuntoPosteLocker }: { dettaglioPuntoPosteLocker: IResponsePuntoPosteLockerDetail | null }
): IThirdPartyReportState => {
  return {
    ...state,
    dettaglioPuntoPosteLocker,
  };
};

const handleResetReteterzaReport = (): IThirdPartyReportState => {
  return {
    reteterzaReport: null,
    selectResponseReteterzaReport: null,
    dettaglioPuntoPoste: null,
    retiLockerReport: null,
    reponsePuntoPosteLocker: null,
    dettaglioPuntoPosteLocker: null,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(RETRIEVE_RETETERZA_REPORT_SUCCESS, handleSaveReteterzaReport),
  on(RETRIEVE_RETILOCKER_REPORT_SUCCESS, handleSaveRetiLockerReport),
  on(RETRIEVE_REPORT_PUNTO_POSTE_LOCKER_SUCCESS, handleRetrievePuntoPosteLocker),
  on(RETRIEVE_DETTAGLIO_PUNTO_POSTE_SUCCESS, handleSaveDettaglioPuntoPoste),
  on(RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER_SUCCESS, handleDettaglioPuntoPosteLocker),
  on(RESET_RETE_TERZA_STORE, handleResetReteterzaReport)
);

export const thirdPartyReportReducer = (
  state: IThirdPartyReportState | undefined,
  action: Action
): IThirdPartyReportState => reducer(state, action);
